module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.tab == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('a', [_vm._v("基本資訊")])]), _vm._v(" "), (_vm.hasCommissionPermission) ? _c('li', {
    class: {
      'active': _vm.tab == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('a', [_vm._v("作廢訂單額度")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 1),
      expression: "tab === 1"
    }],
    staticClass: "box-body form"
  }, [(_vm.$route.name === 'upBrand' && _vm.getRoleType === 99) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除品牌")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.brand_code),
      expression: "brandInfo.brand_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "小英數組合",
      "type": "text",
      "id": "brand-code",
      "minlength": "6",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.brand_code)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCode()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "brand_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n         鍵值(專屬用brand_key)\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.brand_key),
      expression: "brandInfo.brand_key"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "id": "brand-key",
      "minlength": "1",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.brandInfo.brand_key)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityKey()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "brand_key", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.getRoleType === 99) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(數字組合)"), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.name),
      expression: "brandInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.name_short),
      expression: "brandInfo.name_short"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.brandInfo.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "name_short", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌別名\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.nameAliasList,
      "tag-placeholder": "新增品牌別名",
      "placeholder": "新增品牌別名",
      "label": "label",
      "track-by": "value",
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addAliasTag
    },
    model: {
      value: (_vm.brandInfo.name_alias),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "name_alias", $$v)
      },
      expression: "brandInfo.name_alias"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        標語\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.slogan),
      expression: "brandInfo.slogan"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.brandInfo.slogan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "slogan", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        訊息\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.comment),
      expression: "brandInfo.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.brandInfo.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        描述\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.description),
      expression: "brandInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.brandInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        品牌頁介紹\n      ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.introduction),
      expression: "brandInfo.introduction"
    }],
    staticClass: "w-100-p form-control",
    attrs: {
      "name": "introduction",
      "cols": "30",
      "rows": "10",
      "maxlength": "65535"
    },
    domProps: {
      "value": (_vm.brandInfo.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "introduction", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        Youtube影片代碼\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.youtube_video_code),
      expression: "brandInfo.youtube_video_code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.brandInfo.youtube_video_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "youtube_video_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        電子信箱\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.email),
      expression: "brandInfo.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.brandInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n        品牌資訊\n      ")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "前端顯示的品牌資訊",
      "placeholder": "選擇類型",
      "label": "label",
      "track-by": "value",
      "options": _vm.typeOptions,
      "multiple": true,
      "allow-empty": true
    },
    model: {
      value: (_vm.select.websiteSetting),
      callback: function($$v) {
        _vm.$set(_vm.select, "websiteSetting", $$v)
      },
      expression: "select.websiteSetting"
    }
  })], 1), _vm._v(" "), (_vm.select.websiteSetting.length) ? _c('div', {
    staticClass: "form-control"
  }, _vm._l((_vm.select.websiteSetting), function(website) {
    return _c('div', {
      staticClass: "input-group m-y-10"
    }, [_c('span', {
      staticClass: "input-group-addon"
    }, [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("＊ ")]), _vm._v(_vm._s(website.label) + "\n          ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (website.url),
        expression: "website.url"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "網站連結",
        "type": "text",
        "maxlength": "1000"
      },
      domProps: {
        "value": (website.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(website, "url", $event.target.value)
        }
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.is_visible),
      expression: "brandInfo.is_visible"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.brandInfo, "is_visible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("顯示")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("不顯示")])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          LOGO\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.image_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.image_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.brandInfo.image_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為200x200)"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          聯名圖\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.logo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.logo_name) ? _c('div', {
    staticClass: "h-auto img-responsive"
  }, [_c('object', {
    staticClass: "svg-img",
    staticStyle: {
      "height": "90px"
    },
    attrs: {
      "type": "image/svg+xml",
      "data": _vm.brandInfo.logo_name
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-logo-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-logo-load"
    },
    on: {
      "change": _vm.onLogoFileChange
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為300x90)"), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          底圖照片\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.brandInfo.photo_name) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandInfo.photo_name) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.brandInfo.photo_name,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": "brand-photo-load"
    }
  }, [_vm._v("\n            選擇圖片\n          ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-photo-load"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  })])]), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "text-right text-15 text-red"
  }, [_vm._v("(圖片大小為800x460)")]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'crBrand') ? _c('div', {
    staticClass: "photo-setup text-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isCopyStore, true)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = true
      }
    }
  }), _vm._v("\n                是\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isCopyStore, false)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = false
      }
    }
  }), _vm._v("\n                否\n              ")])])])]), _vm._v(" "), (_vm.isCopyStore) ? _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "m-t-20"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          餐點種類\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "tag-placeholder": "餐點種類",
      "placeholder": "餐點種類",
      "label": "label",
      "track-by": "value",
      "options": _vm.mealTagList,
      "multiple": true
    },
    model: {
      value: (_vm.brandInfo.binding_meal_tag_ids),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "binding_meal_tag_ids", $$v)
      },
      expression: "brandInfo.binding_meal_tag_ids"
    }
  })], 1)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌主色\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_main_color_code),
      expression: "brandInfo.clear_main_color_code"
    }],
    attrs: {
      "name": "clearMainColor",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.brandInfo.clear_main_color_code, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_main_color_code", 1)
      }
    }
  }), _vm._v("\n              預設(你訂)\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_main_color_code),
      expression: "brandInfo.clear_main_color_code"
    }],
    staticClass: "m-t-4",
    attrs: {
      "name": "clearMainColor",
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.brandInfo.clear_main_color_code, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_main_color_code", 0)
      }
    }
  }), _vm._v("\n              自訂顏色\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.main_color_code),
      expression: "brandInfo.main_color_code"
    }],
    staticClass: "m-l-10",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.brandInfo.main_color_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "main_color_code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          品牌副色\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-5 text-left"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_sub_color_code),
      expression: "brandInfo.clear_sub_color_code"
    }],
    attrs: {
      "name": "clearSubColor",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.brandInfo.clear_sub_color_code, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_sub_color_code", 1)
      }
    }
  }), _vm._v("\n              預設(你訂)\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.clear_sub_color_code),
      expression: "brandInfo.clear_sub_color_code"
    }],
    staticClass: "m-t-4",
    attrs: {
      "name": "clearSubColor",
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.brandInfo.clear_sub_color_code, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.brandInfo, "clear_sub_color_code", 0)
      }
    }
  }), _vm._v("\n              自訂顏色\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandInfo.sub_color_code),
      expression: "brandInfo.sub_color_code"
    }],
    staticClass: "m-l-10",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.brandInfo.sub_color_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo, "sub_color_code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 2 && _vm.getRoleType === 99),
      expression: "tab === 2 && getRoleType === 99"
    }],
    staticClass: "box-body form text-left"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex align-center h-34"
  }, [_c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.quota_type),
      expression: "orderCommissionSetting.quota_type"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.orderCommissionSetting.quota_type, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "quota_type", 1)
      }
    }
  }), _vm._v("\n            品牌總額度\n            "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderCommissionSetting.quota_type),
      expression: "orderCommissionSetting.quota_type"
    }],
    attrs: {
      "type": "radio",
      "name": "independent"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.orderCommissionSetting.quota_type, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.orderCommissionSetting, "quota_type", 2)
      }
    }
  }), _vm._v("\n            每間門市額度\n            "), _vm._m(7)])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.brandInfo.order_commission_setting.allow_invalid_order_quota),
      expression: "brandInfo.order_commission_setting.allow_invalid_order_quota",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.brandInfo.order_commission_setting.allow_invalid_order_quota)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.brandInfo.order_commission_setting, "allow_invalid_order_quota", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.info) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("獨立產出抽成對帳表門市")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(10), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(11)]) : (_vm.independentStoreList.length === 0) ? _c('tbody', [_vm._m(12)]) : _c('tbody', _vm._l((_vm.independentStoreList), function(row, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.allow_invalid_order_quota))])])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [(!_vm.info && _vm.tab !== 1) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.tab--
      }
    }
  }, [_vm._v("\n      上一步\n    ")]) : _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info && _vm.tab !== _vm.tabTotal) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.tab++
      }
    }
  }, [_vm._v("\n      下一步\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.info && _vm.tab === _vm.tabTotal) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkInputEmpty('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          代碼\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          名稱\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n          縮寫名稱\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("前端顯示\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套用指定門市\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("額度計算")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "此為整個品牌的作廢訂單總額度，非單一門市。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "m-l-5",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "每間門市都有指定的作廢額度。例如 : 當額度設定為 5 筆時，每間門市都有 5 筆的作廢額度。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("每月作廢訂單額度 (筆)\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如需調整請至編輯門市-計費方式設定")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市名稱")]), _vm._v(" "), _c('th', {
    staticClass: "vertical-m",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("額度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "3"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53da6099"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/BrandFormTemp.vue
// module id = 2423
// module chunks = 1